import { Apis } from "libs/apis";
import { dispatch } from "store";
import { setModalClosed, stopLoading } from "store/user-slice";
import Swal from "sweetalert2";
import {
  categoriesSearchDTO,
  CategoryDTO,
} from "utils/helpers/models/categories.dto";
import {
  CategoryLinkedIngredientDTO,
  DietaryLinkedIngredientDTO,
} from "utils/helpers/models/category-linked-ingredient.dto";
import {
  DietariesDTO,
  dietarySearchDTO,
} from "utils/helpers/models/dietaries.dto";

export default function useCategories() {
  const postCategories = async (body: any) => {
    await Apis.postCategory(body)
      .then((res) => {
        if (res.data.status) {
          dispatch(setModalClosed("Categories"));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getCategories = async (
    setCategoriesData: Function,
    setCategoryPaginationState: Function,
    offset?: number,
    limit?: number
  ) => {
    await Apis.getCategories(offset, limit)
      .then((res) => {
        setCategoriesData(res.data.data);
        setCategoryPaginationState(res.data.pagination);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => dispatch(stopLoading()));
  };
  const getCategoryById = async (id: number, setData: any) => {
    await Apis.getCategoryById(id)
      .then((res) => {
        setData(res.data?.category);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const putCategoryById = async (
    id: number,
    setCategoriesData: Function,
    categoriesData: any[],
    data: CategoryDTO,
    body?: any
  ) => {
    await Apis.putCategoryById(id, body)
      .then((res) => {
        if (res?.data?.status) {
          dispatch(setModalClosed("Categories"));

          const updatedCategories = categoriesData.map((category) =>
            category?.category?.id === id
              ? { ...category, category: { ...category.category, ...data } }
              : category
          );

          setCategoriesData(updatedCategories);
        }
      })
      .catch((err) => console.error(err));
  };
  const updateCategoryByStatus = async (id: number, body: any) => {
    await Apis.updateStatusCategories(id, body)
      .then((res) => { })
      .catch((error) => {
        console.error(error);
      });
  };
  const updateCategoryDietary = async (id: number, body: any) => {
    await Apis.updateStatusDietaries(id, body)
      .then((res) => { })
      .catch((error) => {
        console.error(error);
      });
  };
  const postDietaries = async (body: any) => {
    await Apis.postDietaries(body)
      .then((res) => {
        if (res.data.status) {
          dispatch(setModalClosed("Dietaries"));
        }
      })
      .catch((err) => console.error(err));
  };
  const getDietaries = async (
    setDietariesData: any,
    setDietariesPaginationState: Function,
    offset?: number,
    limit?: number
  ) => {
    await Apis.getDietaries(offset, limit)
      .then((res) => {
        setDietariesData(res.data.data);
        setDietariesPaginationState(res.data.pagination);
      })
      .catch((error) => console.error(error));
  };
  const getDietariesById = async (id: number, setData: any) => {
    await Apis.getDietariesById(id)
      .then((res) => {
        setData(res?.data?.response?.diatery);
      })
      .catch((err) => console.error(err));
  };
  const putDietaries = async (
    id: number,
    body: any,
    dietariesData: any[],
    setDietariesData: Function,
    data: DietariesDTO
  ) => {
    await Apis.putDietaries(id, body)
      .then((res) => {
        if (res?.data?.status) {
          dispatch(setModalClosed("Dietaries"));
          const index = dietariesData.findIndex((d) => d.id === id);
          dietariesData[index] = data;
          setDietariesData([...dietariesData]);
        }
      })
      .catch((err) => console.error(err));
  };
  const postCategoryLinkedIngredient = async (
    body: CategoryLinkedIngredientDTO
  ) => {
    await Apis.postCategoryLinkedIngredient(body)
      .then((res) => {
        if (res.data.status) {
          dispatch(setModalClosed("Select Ingredient"));
        }
      })
      .catch((err) => console.error(err));
  };
  const getCategoryLinkedIngredientById = async (
    id: number,
    setData: any,
    setPagination?: Function,
    offset?: number,
    limit?: number,
    append: boolean = false
  ) => {
    await Apis.getCategoryLinkedIngredientById(id, offset, limit)
      .then((res) => {
        const ingredients = res?.data?.data?.category?.ingredients || [];
        const pagination =
          res?.data?.pagination || res?.data?.data?.pagination || null;

        if (append) {
          setData((prev: any[]) => [...(prev || []), ...ingredients]);
        } else {
          setData(ingredients);
        }
        if (setPagination && pagination) {
          setPagination(pagination);
        }
      })
      .catch((err) => console.error(err));
  };
  const getUnLinkedCategoriesIngredients = async (setData: any) => {
    await Apis.getUnLinkedCategoriesIngredients()
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((err) => console.error(err));
  };
  const getIngredientsForSelection = (setData: any) => {
    Apis.getIngredients()
      .then((res) => {
        setData(res.data.ingredients);
      })
      .catch((err) => console.error(err));
  };
  const searchCategoriesIngredients = (
    data: categoriesSearchDTO,
    setData: Function,
    setCategoryPaginationState: Function
  ) => {
    Apis.searchCategoriesIngredients(data)
      .then((res) => {
        console.log(res);

        setData(res?.data?.data);
        setCategoryPaginationState(res?.data?.pagination);
      })
      .catch((err) => console.error(err));
  };
  const postDietaryLinkedIngredient = async (
    id: number,
    body: { ingredientIds: number[] }
  ) => {
    const bodyData = { diateryId: id, ingredientIds: body.ingredientIds };
    await Apis.postDietaryLinkedIngredients(bodyData)
      .then((res) => {
        if (res.data.status) {
          dispatch(setModalClosed("Dietaries Select Ingredient"));
        }
      })
      .catch((err) => console.error(err));
  };
  const getDietariesLinkedIngredientById = (id: number, setData: any) => {
    Apis.getDietariesLinkedIngredientById(id)
      .then((res) => {
        const ingredients = res?.data?.data?.dietary?.ingredients;
        setData(Array.isArray(ingredients) ? ingredients : []);
      })
      .catch((err) => {
        console.error(err);
        setData([]);
      });
  };
  const unLinkedCategoryIngredients = async (
    id: number,
    data: any[],
    setData: Function
  ) => {
    return Apis.unLinkedCategoryIngredients(id)
      .then((res) => {
        if (res.data.status) {
          const index = data.findIndex((c) => c.id === id);
          if (index !== -1) {
            const updatedData = [...data];
            updatedData.splice(index, 1);
            setData(updatedData);
          }
          Swal.fire({
            title: "Success!",
            text: "The ingredient has been unlinked from this category.",
            icon: "success",
          });
        }
        return res;
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  };
  const unLinkedDietaryIngredients = async (
    id: number,
    data: any[],
    setData: Function
  ) => {
    return Apis.unLinkedDietaryIngredients(id)
      .then((res) => {
        if (res.data.status) {
          const index = data.findIndex((c) => c.associationId === id);
          if (index !== -1) {
            const updatedData = [...data];
            updatedData.splice(index, 1);
            setData(updatedData);
          }
          Swal.fire({
            title: "Success!",
            text: "The ingredient has been unlinked from this dietary.",
            icon: "success",
          });
        }
        return res;
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  };
  const getunLinkedDietariesIngredients = (id: number, setData: any) => {
    Apis.getunLinkedDietaries(id)
      .then((res) => {
        const ingredients = res?.data?.data;
        setData(Array.isArray(ingredients) ? ingredients : []);
      })
      .catch((err) => {
        console.error(err);
        setData([]);
      });
  };
  const searchDietaries = (data: dietarySearchDTO, setData: Function, setDietariesPaginationState: Function) => {
    Apis.searchDietaries(data)
      .then((res) => {
        if (res.data.status) {
          setData(res.data.data);
          setDietariesPaginationState(res.data.pagination);
        }
      })
      .catch((err) => console.error(err));
  };
  const searchLinkedIngredeints = (
    categoryId: number,
    ingredientName: string,
    setUnlinkedData: any,
    setPagination?: Function,
    offset?: number,
    limit?: number,
    append: boolean = false
  ) => {
    if (!categoryId || !ingredientName.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Please provide a valid category ID and ingredient name.",
      });
      return;
    }

    Apis.searchLinkedIngredeints(categoryId, ingredientName, offset, limit)
      .then((res: any) => {
        const ingredients = res?.data?.data?.category?.ingredients || [];
        const pagination =
          res?.data?.pagination || res?.data?.data?.pagination || null;

        if (append) {
          setUnlinkedData((prev: any[]) => [...(prev || []), ...ingredients]);
        } else {
          setUnlinkedData(ingredients);
        }
        if (setPagination && pagination) {
          setPagination(pagination);
        }
        return ingredients;
      })
      .catch((err: any) => {
        console.error(err);
        Swal.fire({
          icon: "question",
          title: "404",
          text: "No Ingredients Found.",
        });
      });
  };
  const availableIngredientsForLink = (
    ingredientName: string,
    setSearchdata: any
  ) => {
    Apis.searchAvailableIngredients(ingredientName)
      .then((res) => {
        setSearchdata(res.data.data);
        return res.data.data;
      })
      .catch((err) => console.error(err));
  };
  const searchIngredientsForDietary = async (
    id: number,
    ingredientName: string,
    setDietarySearchData: any
  ): Promise<any[]> => {
    try {
      const res = await Apis.searchIngredientsForDietary(id, ingredientName);
      const ingredients = res?.data?.data?.dietary?.ingredients;
      const list = Array.isArray(ingredients) ? ingredients : [];
      setDietarySearchData(list);
      return list;
    } catch (err) {
      console.error(err);
      setDietarySearchData([]);
      return [];
    }
  };
  const searchAvailableIngredientsForDietary = async (
    ingredientId: number,
    ingredientName: string,
    setUnlinkedData: any
  ): Promise<any[]> => {
    try {
      const response = await Apis.searchAvailableIngredientsForDietary(
        ingredientId,
        ingredientName
      );
      const ingredients = response?.data?.data;
      const list = Array.isArray(ingredients) ? ingredients : [];
      setUnlinkedData(list);
      return list;
    } catch (error) {
      console.error(error);
      setUnlinkedData([]);
      return [];
    }
  };

  return {
    getCategories,
    getCategoryById,
    putCategoryById,
    postDietaries,
    getDietaries,
    getDietariesById,
    putDietaries,
    getUnLinkedCategoriesIngredients,
    unLinkedCategoryIngredients,
    unLinkedDietaryIngredients,
    postCategories,
    getCategoryLinkedIngredientById,
    postCategoryLinkedIngredient,
    postDietaryLinkedIngredient,
    getIngredientsForSelection,
    getDietariesLinkedIngredientById,
    getunLinkedDietariesIngredients,
    searchCategoriesIngredients,
    searchDietaries,
    updateCategoryByStatus,
    updateCategoryDietary,
    searchLinkedIngredeints,
    availableIngredientsForLink,
    searchIngredientsForDietary,
    searchAvailableIngredientsForDietary,
  };
}
